module.exports = __webpack_public_path__ + "static/media/project-img5.26c62b04.png";